/**
 * Scan overlay only when we intend to play it. During loading, metadata can
 * arrive while autoAnimate is still false — rendering both strings then
 * stacked them because RN-web leaves interpolated opacity at 1 until the
 * first animation frame.
 */
export function shouldShowResolutionScan({ autoAnimate, hasTransformation }) {
  return !!(autoAnimate && hasTransformation);
}
